import styled from 'styled-components';

export const ResultTableWrapper = styled.div`
  .ant-table-thead th {
    vertical-align: top;
    background-color: #eef4fa;
    white-space: nowrap;
    padding: 8px 0 8px 16px;
    text-wrap: balance;
  }
  .ant-table-tbody tr:nth-child(odd) {
    background: white;
  }
  .ant-table-tbody tr:nth-child(even) {
    background: #f7f7f8;
  }

  .ant-table-tbody td {
    vertical-align: top;
    padding: 8px 0 8px 16px;
  }
  .ant-pagination {
    font-style: normal;
    font-size: 12px;

    .ant-pagination-item {
      border-radius: 4px;
    }

    .ant-pagination-total-text {
      color: #b8bec5;
      font-weight: 400;
    }

    .anticon {
      vertical-align: 0.2em;
      border-radius: 4px;
    }

    .ant-select {
      font-size: 12px;
      border-radius: 4px;

      .ant-select-item {
        font-size: 12px;
      }
    }
  }
`;
